import { render, staticRenderFns } from "./VolumeForm.vue?vue&type=template&id=139eabe0&scoped=true"
import script from "./VolumeForm.vue?vue&type=script&lang=js"
export * from "./VolumeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139eabe0",
  null
  
)

export default component.exports